module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100"
  }, [(_vm.abrirBancoPrecos) ? _c('bancoPrecos', {
    attrs: {
      "gravaSelecaoItens": _vm.gravaSelecaoItens,
      "toggleBancoPrecos": _vm.toggleBancoPrecos
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.abrirBancoPrecos) ? _c('div', {
    staticClass: "box-body column centered-start cotacao-itens-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column centered-start cotacao-main-container"
  }, [(_vm.abrirDetalheItem) ? _c('div', {
    ref: "detalhamentoContainer",
    staticClass: "column all-centered cotacao-detalhamento-item"
  }, [_c('detalheItemLicitacao', {
    attrs: {
      "itemLicitacao": _vm.itemDetalheSelecionado,
      "toggleDetalhe": _vm.toggleDetalhe
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "column centered-start cotacao-adicionar-container"
  }, [_c('div', {
    staticClass: "row centered-start w-100"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleBancoPrecos(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Abrir Banco de Cotações  ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.limparSelecao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar ")])], 1)]), _vm._v(" "), _c('div', {
    ref: "nomeItemCotacao",
    staticClass: "column all-start cotacao-input-container"
  }, [_c('label', {
    staticClass: "f-required"
  }, [_vm._v("Item de cotação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeItem),
      expression: "nomeItem"
    }],
    staticClass: "form-control",
    class: _vm.errorInput ? 'error-input' : '',
    attrs: {
      "type": "text",
      "placeholder": "Digite o nome do item a ser cotado, ref. histórico do cronograma."
    },
    domProps: {
      "value": (_vm.nomeItem)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeItem = $event.target.value
      }, function($event) {
        _vm.errorInput = false
      }]
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column centered-start cotacao-titulo-container"
  }, [_c('div', {
    staticClass: "cotacao-titulo"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Itens Selecionados\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between cotacao-subtitulo"
  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.table.items.length) + ") itens que "), _c('b', [_vm._v("estão sendo utilizados")]), _vm._v(" para compor a cotação")])])]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItem(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "descricao_item",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-start banco-precos-table-descricao-container"
        }, [_c('div', {
          staticClass: "banco-precos-table-descricao",
          attrs: {
            "title": row.value
          }
        }, [_vm._v("\n                  [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
      }
    }, {
      key: "valor_item",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
      }
    }, {
      key: "selecionado",
      fn: function(row) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (row.item.selecionado),
            expression: "row.item.selecionado"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(row.item.selecionado) ? _vm._i(row.item.selecionado, null) > -1 : (row.item.selecionado)
          },
          on: {
            "change": function($event) {
              var $$a = row.item.selecionado,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(row.item, "selecionado", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(row.item, "selecionado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(row.item, "selecionado", $$c)
              }
            }
          }
        })]
      }
    }, {
      key: "data_resultado_licitacao",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(row.value !== '' ? _vm.moment.utc(row.value).format('MM/YYYY') : '-') + "\n            ")]
      }
    }, {
      key: "sigla_uf",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(row.value !== '0' ? row.value : '-') + "\n            ")]
      }
    }], null, false, 2380468564)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.tableSaneados.items.length > 0) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "column centered-start cotacao-titulo-container"
  }, [_c('div', {
    staticClass: "cotacao-titulo"
  }, [_c('i', {
    staticClass: "fa fa-recycle"
  }), _vm._v(" Itens Saneados\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between cotacao-subtitulo"
  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.tableSaneados.items.length) + ") itens que foram "), _c('b', [_vm._v("saneados")]), _vm._v(" do cálculo da cotação")])])]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableSaneados.bordered,
      "items": _vm.tableSaneados.items,
      "hover": _vm.tableSaneados.hover,
      "fields": _vm.tableSaneados.fields,
      "filter": _vm.tableSaneados.filter,
      "current-page": _vm.tableSaneados.currentPage,
      "per-page": _vm.tableSaneados.perPage,
      "sort-by": _vm.tableSaneados.sortBy,
      "sort-desc": _vm.tableSaneados.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableSaneados, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableSaneados, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableSaneados, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableSaneados, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItem(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "descricao_item",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-start"
        }, [_c('div', {
          staticClass: "banco-precos-table-descricao",
          attrs: {
            "title": row.value
          }
        }, [_vm._v("\n                  [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
      }
    }, {
      key: "valor_item",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
      }
    }, {
      key: "diagnostico",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cotacao-saneado-row"
        }, [_c('i', {
          class: 'fa ' + (parseFloat(row.item.valor_item) > _vm.calculoAmostral.LS ? 'fa-arrow-up' : ' fa-arrow-down')
        }), _vm._v(" " + _vm._s(parseFloat(row.item.valor_item) > _vm.calculoAmostral.LS ? 'Acima do Limite Superior' : 'Abaixo do Limite Inferior') + "\n              ")])]
      }
    }], null, false, 2836757405)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.tableSaneados.items.length,
      "per-page": _vm.tableSaneados.perPage
    },
    model: {
      value: (_vm.tableSaneados.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tableSaneados, "currentPage", $$v)
      },
      expression: "tableSaneados.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tableContaminados.items.length > 0) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "column centered-start cotacao-titulo-container"
  }, [_c('div', {
    staticClass: "cotacao-titulo"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Itens contaminados\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between cotacao-subtitulo"
  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.tableContaminados.items.length) + ") itens que foram "), _c('b', [_vm._v("removidos")]), _vm._v(" do cálculo da cotação por discrepância muito grande de valor")])])]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableContaminados.bordered,
      "items": _vm.tableContaminados.items,
      "hover": _vm.tableContaminados.hover,
      "fields": _vm.tableContaminados.fields,
      "filter": _vm.tableContaminados.filter,
      "current-page": _vm.tableContaminados.currentPage,
      "per-page": _vm.tableContaminados.perPage,
      "sort-by": _vm.tableContaminados.sortBy,
      "sort-desc": _vm.tableContaminados.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableContaminados, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableContaminados, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableContaminados, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableContaminados, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItem(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "descricao_item",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-start banco-precos-table-descricao-container"
        }, [_c('div', {
          staticClass: "banco-precos-table-descricao",
          attrs: {
            "title": row.value
          }
        }, [_vm._v("\n                  [" + _vm._s(row.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
      }
    }, {
      key: "valor_item",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
      }
    }, {
      key: "diagnostico",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cotacao-contaminado-row"
        }, [_c('i', {
          staticClass: "fa fa-warning",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(parseFloat(row.item.valor_item) > _vm.calculoAmostral.LS ? 'Muito Acima do Limite Superior' : 'Abaixo do Limite Inferior') + "\n              ")])]
      }
    }], null, false, 3502277068)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.tableContaminados.items.length,
      "per-page": _vm.tableContaminados.perPage
    },
    model: {
      value: (_vm.tableContaminados.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tableContaminados, "currentPage", $$v)
      },
      expression: "tableContaminados.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tableRemovidosManual.items.length > 0) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "column centered-start cotacao-titulo-container"
  }, [_c('div', {
    staticClass: "cotacao-titulo"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Itens Removidos Manualmente\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between cotacao-subtitulo"
  }, [_c('div', [_vm._v("Confira os (" + _vm._s(_vm.tableRemovidosManual.items.length) + ") itens que foram "), _c('b', [_vm._v("removidos manualmente")]), _vm._v(" pelo usuário. (Pendente de Validação)")])])]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableRemovidosManual.bordered,
      "items": _vm.tableRemovidosManual.items,
      "hover": _vm.tableRemovidosManual.hover,
      "fields": _vm.tableRemovidosManual.fields,
      "filter": _vm.tableRemovidosManual.filter,
      "current-page": _vm.tableRemovidosManual.currentPage,
      "per-page": _vm.tableRemovidosManual.perPage,
      "sort-by": _vm.tableRemovidosManual.sortBy,
      "sort-desc": _vm.tableRemovidosManual.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableRemovidosManual, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableRemovidosManual, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableRemovidosManual, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableRemovidosManual, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItem(row.item.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "item.descricao_item",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-start banco-precos-table-descricao-container"
        }, [_c('div', {
          staticClass: "banco-precos-table-descricao",
          attrs: {
            "title": row.value
          }
        }, [_vm._v("\n                  [" + _vm._s(row.item.item.id) + "] " + _vm._s(row.value) + "\n                ")])])]
      }
    }, {
      key: "item.valor_item",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm._f("real")(row.value)) + "\n            ")]
      }
    }, {
      key: "justificativa",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-centered cotacao-removido-manual-row"
        }, [_c('i', {
          staticClass: "fa fa-warning",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value) + "\n              ")])]
      }
    }], null, false, 3871503153)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.tableRemovidosManual.items.length,
      "per-page": _vm.tableRemovidosManual.perPage
    },
    model: {
      value: (_vm.tableRemovidosManual.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tableRemovidosManual, "currentPage", $$v)
      },
      expression: "tableRemovidosManual.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.universoAmostral.length > 0) ? _c('div', {
    staticClass: "row-flex centered-start cotacao-resumo-container"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('b', [_vm._v("Resumo da Cotação")])]) : _vm._e(), _vm._v(" "), (_vm.universoAmostral.length > 0) ? _c('div', {
    staticClass: "column all-centered cotacao-calculo-container"
  }, [_c('div', {
    staticClass: "row-flex all-centered cotacao-calculo-tabela-container"
  }, [_c('div', {
    staticClass: "row-flex all-centered cotacao-tabelas"
  }, [_vm._m(1), _vm._v(" "), _c('tr', {
    staticClass: "column centered-start cotacao-tabela"
  }, [_c('td', {
    staticClass: "cotacao-tabela-header"
  }, [_vm._v("Universo Amostral Selecionado")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.media)))]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.DP)))]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm.calculoAmostral.CV) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LS)))]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.calculoAmostral.LI)))])]), _vm._v(" "), _c('tr', {
    staticClass: "column centered-start cotacao-tabela"
  }, [_c('td', {
    staticClass: "cotacao-tabela-header"
  }, [_vm._v("Universo Amostral Saneado")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.calculoFinal.media)) + " (Média Saneada)")])]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% (CV Saneado)*")])]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("-")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "column all-centered cotacao-indicativo"
  }, [_c('div', {
    staticClass: "column all-centered cotacao-resumo"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column all-end resumo-container"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.table.items.length + _vm.tableSaneados.items.length) + " ")]), _vm._v(" Itens Encontrados\n              ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.tableSaneados.items.length) + " ")]), _vm._v(" Itens Saneados\n              ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.table.items.length) + " ")]), _vm._v(" Itens Cotados\n              ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.calculoFinal.CV) + "% ")]), _vm._v(" Coeficiente de Variação\n              ")])]), _vm._v(" "), (_vm.calculoFinal.CV <= 25 && _vm.calculoFinal.CV !== 0) ? _c('div', {
    staticClass: "row-flex all-centered diagnostico-card diagnostico-ok"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  }), _vm._v(" CV calculado indica razoável homogeneização do Valor.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.calculoFinal.CV > 25) ? _c('div', {
    staticClass: "row-flex all-centered diagnostico-card diagnostico-atencao"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" O CV calculado indica baixa homogeneização do Valor, atenção. Sujeito a análise.\n            ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between cotacao-media-saneada-container"
  }, [_vm._v("\n        Preço referência da Amostra (Média Saneada):\n        "), _c('span', [_vm._v("\n          " + _vm._s(_vm._f("real")(_vm.calculoFinal.media)) + "\n        ")])]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start w-100 gap-5 button-cotacao-container"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarCotacaoItem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar Cotação de Item ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleAdicionarItem(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start cotacao-header-container"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('b', [_vm._v("Cotação de Preços")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "column centered-start cotacao-tabela"
  }, [_c('td', {
    staticClass: "cotacao-tabela-header"
  }, [_vm._v("Variáveis")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Média")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Desvio Padrão (DP):")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Coeficiente de Variação (CV):")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Limite Superior (LS):")]), _vm._v(" "), _c('td', {
    staticClass: "cotacao-tabela-linha"
  }, [_vm._v("Limite Inferior (LI):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start cotacao-titulo"
  }, [_c('i', {
    staticClass: "fa fa-map-pin"
  }), _vm._v(" Resumo:\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex all-end w-100"
  }, [_c('i', [_vm._v("*CV menor que 25% indica razoável homogeneidade.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f4d4fe4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/cotacaoPrecos.vue
// module id = 1864
// module chunks = 1